import { render, staticRenderFns } from "./RoleUserView.vue?vue&type=template&id=b043ef86&"
import script from "./RoleUserView.vue?vue&type=script&lang=js&"
export * from "./RoleUserView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports